// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pathList {
    flex: 1 0 auto;
    overflow: auto;
    padding-right: 7px;
}

.pathCaption {
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/dialogs/containerpath.chooser.dialog.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".pathList {\n    flex: 1 0 auto;\n    overflow: auto;\n    padding-right: 7px;\n}\n\n.pathCaption {\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
